import * as React from "react";
import {Option} from "ts-option";
import {FormGroupProps} from "../../../../common/props/FormGroupProps";
import {FocusableProps} from "../../../../common/props/FocusableProps";
import {PressableProps} from "../../../../common/props/PresableProps";
import FormGroup from "../../../../../hiberUiKit/src/molecules/FormGroup/FormGroup";
import SelectActivityTemplate from "./SelectActivityTemplate";
import DictionaryItem from "../../../../../model/dictionary/DictionaryItem";
import {DisableableProps} from "../../../../common/props/DisableableProps";

type Props = FormGroupProps<string> & DisableableProps & FocusableProps & PressableProps;

/**
 * Activity template form view group.
 */
export default class ActivityTemplateFormGroup extends React.PureComponent <Props, {}> {
	constructor(props: Props) {
		super(props);
		this.onChange = this.onChange.bind(this);
	}

	render() {
		return (
			<FormGroup label={this.props.label} error={this.props.field.firstError().getOrElse("")}>
				<SelectActivityTemplate
					selectedId={this.props.field.getOptionalValue()}
					onChanged={this.onChange}
					disabled={this.props.disabled}
				/>
			</FormGroup>
		);
	}

	/**
	 * Callback on changed activity template.
	 * @param activityTemplate
	 */
	onChange(activityTemplate: Option<DictionaryItem>) {
		this.props.onChange(this.props.field.updateValue(activityTemplate.map(at => at.id)));
	}
}
